import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const IFERROR = () => {
  return (
    <CardSection id="IFERROR" title="IFERROR">
      <Paragraph>
        지정된 열 내의 오류에 대해 셀 값을 확인합니다. 오류가 발견되면 지정한
        값이 반환됩니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>IFERROR(ARGUMENT, VALUE)</Paragraph>
        <Ul>
          <Li>
            <b>ARGUMENT</b>는 확인하려는 열입니다.
          </Li>
          <Li>
            <b>VALUE</b>는 열 셀에 오류가 있는 경우 반환할 값입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>IFERROR(`Column`, "N/A")</Paragraph>
        <Img src="computeIfError" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>VALUE</b>는 텍스트 문자열이나 숫자 값, 텍스트 문자열이나
          숫자 값을 포함하는 열, 텍스트 문자열이나 숫자 값을 반환하는 함수일 수
          있습니다.
        </Paragraph>
        <Paragraph>
          오류가 발견되지 않은 셀의 경우 셀의 원래 값이 반환됩니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
